import { createBrowserRouter } from "react-router-dom";
import { PublicRoutes } from "./publicRoute";
import { PrivateRoutes } from "./privateRoute";

const routes = [...PublicRoutes, ...PrivateRoutes];

const appRoutes = createBrowserRouter(routes);

export default appRoutes;
